import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteEmailTemplate: (
  fetchContext: FetchContext,
  programId: number, 
  emailTemplateId: number,
  accessToken?: string) => Promise<void> = (fetchContext, programId, emailTemplateId, accessToken) => 
    fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/email-templates/${emailTemplateId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete email template', false));
